// `text` with every occurrence of the search's `terms` marked, ignoring case.
const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export default function Highlight({ text, terms }) {
    const words = (terms || []).filter(Boolean);
    if (!text || !words.length) return text ?? null;
    // Longest first, so "endpoints" wins over "end" where both match.
    const pattern = new RegExp(`(${[...words].sort((a, b) => b.length - a.length).map(escape).join("|")})`, "gi");
    // Splitting on a capturing group puts the matches at the odd indexes.
    return String(text).split(pattern).map((part, i) => (i % 2
        ? <mark key={i} className="rounded-[2px] bg-[color-mix(in_srgb,var(--green)_28%,transparent)] px-[1px] text-[color:var(--ink)]">{part}</mark>
        : part));
}
